import { ClockOutlineIcon } from './ClockOutlineIcon';

/**
 * author: Google
 * id E3A4F70D-92EF-4115-BBB3-3BE68A788F5D
 * name clock-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-outline.svg
 * tags
 * - Date / Time 
 */
export const AccessTimeIcon = ClockOutlineIcon;
export default AccessTimeIcon